
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Store } from '@ngrx/store';
import { SSEFunctions } from './shared/SSE/sse-functions';
import { appState } from './shared/interfaces/appState.interface';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent extends SSEFunctions implements OnInit, OnDestroy {
  constructor(private router: Router) {
    super();
  }

  ngOnInit() {
    // Initialize SSE subscriptions
    this.initializeSubscriptions();

    // Handle route changes
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Ejecutar el script cuando se complete la navegación a una nueva ruta
        (window as any).handleRouteChange();
      }
    });
  }

  ngOnDestroy() {
    // Clean up SSE connection and subscriptions
    this.closeConnection();
  }
}

